import React from "react";
import { useLocation, Link } from "react-router-dom";
import styled from "styled-components";
import { useRef, useEffect, useState } from "react";
import Header from "../components/Header";
const ReactDOMServer = require("react-dom/server");
const HtmlToReactParser = require("html-to-react").Parser;

const Wrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;
  background-color: black;
  overflow: hidden;
  cursor: pointer;
`;

const BgImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

const TextWrapper = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  user-select: none; /* Standard */
  z-index: 1;
`;

const Title = styled.div`
  font-family: Roumald;
  font-size: 1.1em;
  color: white;
  text-transform: lowercase;
  line-height: 1.2;
  cursor: pointer;
  background: rgba(139, 139, 139, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 0.2em 0.75em;
`;

const Name = styled(Title)`
  font-family: Roumald;
  font-size: 2em;
  text-transform: lowercase;
  cursor: pointer;
`;

const HeaderMenu = styled.div`
  position: absolute;
  top: 1vh;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  font-family: Roumald;
  color: white;
  width: max-content;
  font-size: 1.1em;
  text-transform: lowercase;
  background: rgba(0, 0, 0, 1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 0.2em 0.75em;
  z-index: 1000;
  text-align: center;
`;

// Resolves only once the browser has fully decoded the image, so swapping
// the background never shows a blank/white frame mid-decode.
function preloadImage(src) {
  return new Promise((resolve) => {
    if (!src) return resolve(null);
    const img = new Image();
    img.src = src;
    const done = () => resolve(img);
    if (img.decode) {
      img.decode().then(done).catch(done);
    } else {
      img.onload = done;
      img.onerror = done;
    }
  });
}

export default function ProjectMobile() {
  const wrapperRef = useRef();
  const textWrapperRef = useRef();
  const titleRef = useRef();
  const typeRef = useRef();
  const yearRef = useRef();
  const roleRef = useRef();
  const creditsRef = useRef();
  const headerRef = useRef();
  const abstractRef = useRef();
  const location = useLocation();
  const project = location.state?.project;
  const slides =
    project?.mobileImages && project.mobileImages.length
      ? project.mobileImages
      : project?.images || [];
  const [image, setImage] = useState();
  const [imageIndex, setImageIndex] = useState(0);
  const [abstractOpen, setAbstractOpen] = useState(false);
  var refs = [titleRef, yearRef, typeRef, roleRef, creditsRef, headerRef];
  const preloadedRef = useRef([]);
  // Two stacked <img> layers we crossfade between, so switching images
  // never relies on a background-image swap (which can flash white on
  // WebKit while the GPU uploads the new texture).
  const layerARef = useRef();
  const layerBRef = useRef();
  const activeLayerRef = useRef("A");

  // Preload + fully decode every slide up front, keeping references so
  // Safari doesn't garbage-collect (and abort) the in-flight loads.
  useEffect(() => {
    let cancelled = false;
    Promise.all(slides.map(preloadImage)).then((imgs) => {
      if (!cancelled) preloadedRef.current = imgs;
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);

  useEffect(() => {
    if (!project) return;
    const src = slides[imageIndex];
    if (!src) return;

    const showingA = activeLayerRef.current === "A";
    const activeEl = showingA ? layerARef.current : layerBRef.current;
    const nextEl = showingA ? layerBRef.current : layerARef.current;
    if (!nextEl || (activeEl && activeEl.src === src)) return;

    const reveal = () => {
      nextEl.style.opacity = "1";
      if (activeEl) activeEl.style.opacity = "0";
      activeLayerRef.current = showingA ? "B" : "A";
      console.log("image " + imageIndex + " of " + slides.length);
    };

    if (nextEl.src === src && nextEl.complete) {
      reveal();
    } else {
      nextEl.onload = reveal;
      nextEl.src = src;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageIndex, project]);

  useEffect(() => {
    if (!project || !abstractRef.current) return;
    abstractRef.current.innerText = "+ read more";
    setAbstractOpen(false);
    if (creditsRef.current) {
      creditsRef.current.innerText = "+ credits";
    }
  }, [project]);

  function changeImage(e) {
    e.stopPropagation();
    if (!project) return;
    //  console.log("image index at click: " + imageIndex);
    if (imageIndex + 1 <= slides.length && slides[imageIndex + 1]) {
      setImageIndex(imageIndex + 1);
    } else {
      console.log("no image");
      setImageIndex(0);
    }
  }

  function toggleAbstract(e) {
    e.stopPropagation();
    if (!project || !abstractRef.current) return;
    if (!abstractOpen) {
      abstractRef.current.innerText = project.abstract;
      if (creditsRef.current) {
        creditsRef.current.innerText = project.credits;
      }
      setAbstractOpen(true);
    } else {
      abstractRef.current.innerText = "+ read more";
      if (creditsRef.current) {
        creditsRef.current.innerText = "+ credits";
      }
      setAbstractOpen(false);
    }
  }

  // parse HTML from WP API to React element
  const htmlToReactParser = new HtmlToReactParser();
  const reactElement = project
    ? htmlToReactParser.parse(project.abstract)
    : null;

  if (!project) {
    return null;
  }

  return (
    <Wrapper ref={wrapperRef}>
      <BgImage ref={layerARef} src={slides[0]} alt="" style={{ opacity: 1 }} />
      <BgImage ref={layerBRef} alt="" style={{ opacity: 0 }} />
      <Link to="/" style={{ textDecoration: "none" }}>
        <HeaderMenu>Nina Kunzendorf</HeaderMenu>
      </Link>
      <TextWrapper ref={textWrapperRef} onClick={changeImage}>
        <Title ref={titleRef} style={{ color: "blue" }}>
          {project.title}
        </Title>
        <Title ref={typeRef}>{project.type}</Title>
        <Title ref={roleRef}>{project.year}</Title>
        <Title ref={yearRef}>{project.location}</Title>
        <Title ref={roleRef}>{project.role}</Title>
        <Title
          ref={abstractRef}
          onClick={toggleAbstract}
          style={{ maxWidth: "80vw" }}
        >
          + read more
        </Title>

        <Link to="/" style={{ textDecoration: "none" }}>
          <Name ref={headerRef} style={{ display: "none" }}>
            nina kunzendorf
          </Name>
        </Link>
      </TextWrapper>
    </Wrapper>
  );
}
